// functions
function goToSection__scroll(elRef, distance, speedAnimation = 700) {
    var el = $(elRef);
    var goScroll = $(el).offset().top;
    setTimeout(function(){
        $('html, body').animate({
            scrollTop: goScroll - distance
        }, speedAnimation);
    }, 10);
}

if($('#page_valorizacaoPessoas').length || $('#page_progProj').length){
    var element = location.hash;
    if(element !== '' && element!== undefined){
        goToSection__scroll($(element),120, 100);
    }
}

// components
if ($('.c-innerHeader__scrollLink').length) {
    var c_scrollLink = $('.c-innerHeader__scrollLink');

    c_scrollLink.on('click', function(){
        goToSection__scroll('main', 0);
    });
}
if($('.c-innerPage__navSections').length) {
    var c_navSection = {
        navSection: $('.c-innerPage__navSections'),
        offset: $('.c-innerPage__navSections').offset(),
        el_a: $('.c-innerPage__navSections a'),
        el_a_first: $('.c-innerPage__navSections li:first-of-type a')
    };

    c_navSection.el_a_first.addClass('firstLiInNavixed');

    // navegacao entre as sections
    c_navSection.el_a.on('click', function(event) {
        event.preventDefault();
        var sectionDestiny = $(this).attr('href');
        var sectionDestiny_offset = $(sectionDestiny).offset().top;
        var scrollEfetuado = $('html, body').scrollTop();
        if (scrollEfetuado >= sectionDestiny_offset) {
            if($(this).hasClass('firstLiInNavixed')) {
                goToSection__scroll(sectionDestiny, 180);
            } else {
                goToSection__scroll(sectionDestiny, 180);
            }
        } else {
            goToSection__scroll(sectionDestiny, 60);
        }
    });

    // deixa o nav fixo
    $(window).on('scroll', function(){
       var scrollEfetuado = $('html, body').scrollTop();

       if (scrollEfetuado >= c_navSection.offset.top) {
           c_navSection.navSection.addClass('is-fixed');
           $('main').css('padding-top', 60);

           if($('.defaultNav--scroll').hasClass('defaultNav--hide')) {
               c_navSection.navSection.removeClass('navMenuIsOpen');
           } else {
               c_navSection.navSection.addClass('navMenuIsOpen');
           }

       } else {
           c_navSection.navSection.removeClass('is-fixed').removeClass('navMenuIsOpen');
           $('main').css('padding-top', 0);
       }
    });
}

// sections
if ($('.defaultNav').length) {
    var scroll_init = 0;
    $(window).on('scroll', function(event) {
        var scroll_body = $(this).scrollTop();
        var nav = $('nav');

        /*
            Aplica a classe que contem o estilo
            primário para o nav quando a pagina
            executar o evento scroll
        */
        if (scroll_body > 99) {
            nav.addClass("defaultNav--scroll");
        } else {
            nav.removeClass("defaultNav--scroll");
        }

        /*
            Quando a página rolar 600px pra baixo o nav
            desaparece e recebe a classe "middle" para
            identificar o estado.
        */
        if (scroll_body > 600) {
            nav.addClass("defaultNav--hide");
            nav.addClass("defaultNav--middle");
        } else {
            nav.removeClass("defaultNav--hide");
            nav.removeClass("defaultNav--middle");
        }

        /*
            verifica se o scroll da página foi
            pra cima, caso sim faz o menu aparecer.
        */
        if (scroll_body < scroll_init) {
            nav.removeClass("defaultNav--hide");
        }

        // var referencia
        scroll_init = scroll_body;
    });

    $(window).on('load', function() {
        var scroll_body_load = $(this).scrollTop();
        console.log(scroll_body_load);
        if (scroll_body_load > 0) {
            setTimeout(function(){
                $('nav').addClass("defaultNav--middle");
                $('nav').removeClass("defaultNav--hide");
                $('nav').addClass('teste');
                $('.c-innerPage__navSections').removeClass('is-fixed');
            }, 30);
        }
    });

    // open/close hamburguer menu
    $('.c-hamburguer').on('click', function() {
        $('.globalNav__mapSite').click();
    });

    // close hamburguer menu
    $('.defaultNav__maskMenu').on('click', function() {
        $('.c-hamburguer').removeClass('is-active');
        $('.defaultNav__contentNav').removeClass('is-active');
        $('.defaultNav__maskMenu').removeClass('is-active');
        $('.u-maxRow').removeClass('nav__is-active');
        $('body').removeClass('u-overflowBlocked');
    });

    // abrir menu sub menu
    $('.menu__withSub > a').on('click mouseenter', function() {
        $('.menu__firstSub').removeClass('menu__firstSub--open');
        $(this).parent('li').children('.menu__firstSub').addClass('menu__firstSub--open');
        $('.maskMenu__menuWithSub').addClass('is-active');
    });
    $('.menu__firstSub > li').on('mouseenter click', function() {
        if ($(this).hasClass('menu__secondSub')) {
            $('.menu__secondSub__itens').addClass('menu__secondSub__itens--open');
        } else {
            $('.menu__secondSub__itens').removeClass('menu__secondSub__itens--open');
        }
    });

    // fechar todos os submenus
    function closeAllSubMenus() {
        $('.menu__secondSub__itens').removeClass('menu__secondSub__itens--open');
        $('.menu__firstSub').removeClass('menu__firstSub--open');
        $('.maskMenu__menuWithSub').removeClass('is-active');
    }
    $('.maskMenu__menuWithSub').on('click mouseenter', function() {closeAllSubMenus()});
    $('.menu__firstSub').on('mouseleave', function() {closeAllSubMenus()});
    $('.menu__withSub').mouseleave(function() {closeAllSubMenus()});
}

// mega menu
function makeMegaMenu() {
    var props = {
        vp_width = $(window).width(),
        menu_width = 370,
        container_width = 1200,
        padding_final = (vp_width - container_width) / 2,
        width_final = menu_width + padding_final,
    };

    var el = {
        gatilho_mapSite = $('.globalNav__mapSite'),
        bodyPage = $('body'),
        mapSite = $('#megaMenu'),
        mapSite_mask = $('.l-megaMenu__mask'),
        mapSite_heroBlock = $('.l-megaMenu__hero'),
        gatilho_mapSite_item = $('.l-megaMenu .megaMenu__primaryList .titleBox'),
    };

    $('.l-megaMenu__hero').css('padding-right', props.padding_final);
    $('.l-megaMenu__hero').css('width', props.width_final);

    el.gatilho_mapSite.on('click', function() {
        el.bodyPage.css('overflow', 'hidden');
        el.mapSite.addClass('is-open');
        el.mapSite_mask.addClass('is-open');
        el.mapSite_heroBlock.addClass('is-open');
    });

    el.gatilho_mapSite_item.on('click', function() {
        console.log('teste');
        $(this).parent().toggleClass('is-open');
    });

    el.mapSite_mask.on('click', function() {
        el.bodyPage.css('overflow', 'auto');
        el.mapSite.removeClass('is-open');
        el.mapSite_mask.removeClass('is-open');
        el.mapSite_heroBlock.removeClass('is-open');
    });
}
$(window).on('resize', function(){makeMegaMenu();});
$(window).on('load', function(){makeMegaMenu();});

if ($('#megaSearch').length) {
    var inputStart = $('.globalNav__search input');
    var inputEnd = $('#megaSearch input');
    var megaSearch = $('#megaSearch');
    var maskSearch = $('#megaSearch .maskSearch');

    inputStart.on('click', function(){
        inputStart.blur();
        megaSearch.addClass('is-active');
        $('body').css('overflow', 'hidden');
        setTimeout(function(){
            inputEnd.focus().addClass('teste');
        }, 250);
    });
    maskSearch.on('click', function() {
        megaSearch.removeClass('is-active');
        $('body').css('overflow', 'auto');
    })
}
$("#formNews").validate({
    submitHandler: function (form) {
        $(form).ajaxSubmit({
            //target: 'status-envio',
            beforeSubmit: function () {
                Swal.fire({
                    title: 'Enviando, aguarde...',
                    showConfirmButton: false,
                    onBeforeOpen: function() {
                        Swal.showLoading()
                    }
                });
                $('#btnNews').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                if(parseInt(result[0].charAt(result[0].length-1)) == 1){
                    Swal.fire({
                        type: 'success',
                        title: 'Enviado com sucesso!',
                        showConfirmButton: false,
                        timer: 2000,
                        onClose: function() {
                            setTimeout(function(){
                                $('#btnNews').attr('disabled',false);
                                $("#formNews .field").val('');
                                $("#descadastrar").prop('checked',false);
                                $("#msgUnsubescrib").fadeOut();
                                $("#formNews .field").removeClass('error');
                            },500)
                        }
                    });
                }else{
                    Swal.fire({
                        type: 'error',
                        title: 'Atenção!',
                        text: result,
                        showConfirmButton: false,
                        timer: 3000,
                        onClose: function() {
                            setTimeout(function(){
                                $('#btnNews').attr('disabled', false);
                            },500)
                        }
                    });
                }
            }
        });
    }
});

$(document).on('focus', '.field-hp', function() {
    $('.help-block').show();
});

$(document).on('focus', '.field-news', function() {
    $('#msgUnsubescrib').fadeIn();
});

$('.openClose').on('click', function(e) {
    e.preventDefault();
    $(this).next().toggleClass('d-none');
});

